import { render } from "./DashboardLoginView.vue?vue&type=template&id=25a2076f"
import script from "./DashboardLoginView.vue?vue&type=script&lang=js"
export * from "./DashboardLoginView.vue?vue&type=script&lang=js"

import "./DashboardLoginView.vue?vue&type=style&index=0&id=25a2076f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__